export default {
    methods: {
        /**
         * Verifica si la cadena de string contiene sólo caracteres numericos
         * @param {string} value
        */
        isNumber(value) {
            var numbers = /^[0-9]+$/;
            return value.match(numbers);
        },

        /**
         * Elimina caracteres alfabeticos
         * @param {string} value
        */
        deleteString(value) {
            return value.replace(/[a-z-A-Z-\W-\D]/g, "");
        },
        /**
         * Obtiene una cadena de caraceres de solo valor numerico.
         * @param {string} value
        */
        getNumber(value) {
            if (this.isNumber(value)) return value;
            else {
                const number = this.deleteString(value);
                return number;
            }
        },
        /**
         * Formatea el valor numérico para agregar los apostrofes de millon y los puntos de mil
         * @param {string} copyNumber
        */
        formaterCurrency(value) {
            const number = this.getNumber(value);
            let result = number.replace(/(\d)(?=(\d\d\d\d\d\d)+(?!\d))/g, "$1'");
            result = result.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
            return result;
        },
        /**
         * Remueve los puntos y apostrofes
         * @param {string} number
        */
        removeFormatter(number) {
            const _number = this.getNumber(number);
            let result = _number.replace(/[',.]/g, "");
            return parseInt(result);
        },
        validateKeyBoards(key) {
            const keysBoard = ["Backspace", "Delete"];
            return !keysBoard.includes(key);
        },
    },
}
